import { createContext, useContext, useState, useEffect, useCallback } from "react";
import client from "@/lib/api";

const Ctx = createContext({ unread: 0, friendsBadge: 0, suggestionsBadge: 0, newsBadge: 0, remindersPending: 0, refresh: () => {}, clearUnread: () => {}, clearNewsBadge: () => {}, clearSuggestionsBadge: () => {}, clearFriendsBadge: () => {} });

export function NotificationsProvider({ children }) {
  const [unread, setUnread] = useState(0);
  const [friendsBadge, setFriendsBadge] = useState(0);
  const [suggestionsBadge, setSuggestionsBadge] = useState(0);
  const [newsBadge, setNewsBadge] = useState(0);
  const [remindersPending, setRemindersPending] = useState(0);

  const refresh = useCallback(() => {
    client.get("/notifications").then((r) => setUnread(r.data.unread || 0)).catch(() => {});
    client.get("/friends/requests/badge").then((r) => setFriendsBadge(r.data.count || 0)).catch(() => {});
    client.get("/friends/suggestions/badge").then((r) => setSuggestionsBadge(r.data.count || 0)).catch(() => {});
    client.get("/news/unseen").then((r) => setNewsBadge(r.data.count || 0)).catch(() => {});
    client.get("/reminders/coming-soon").then((r) => setRemindersPending((r.data.reminders || []).length)).catch(() => {});
  }, []);

  useEffect(() => {
    refresh();
    const t = setInterval(refresh, 60000);
    return () => clearInterval(t);
  }, [refresh]);

  const clearUnread = useCallback(() => setUnread(0), []);
  const clearNewsBadge = useCallback(() => setNewsBadge(0), []);
  const clearSuggestionsBadge = useCallback(() => setSuggestionsBadge(0), []);
  const clearFriendsBadge = useCallback(() => {
    setFriendsBadge(0);
    client.post("/friends/requests/seen").catch(() => {});
  }, []);

  return <Ctx.Provider value={{ unread, friendsBadge, suggestionsBadge, newsBadge, remindersPending, refresh, clearUnread, clearNewsBadge, clearSuggestionsBadge, clearFriendsBadge }}>{children}</Ctx.Provider>;
}

export const useNotifications = () => useContext(Ctx);
